'use client'
import { useSyncExternalStore } from 'react'
import { usePathname } from 'next/navigation'
import Script from 'next/script'
import { isPrivateWorkspaceUrl } from '@/lib/analytics-privacy'

const subscribe = () => () => {}
const clientReady = () => true
const serverReady = () => false
const gaId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? 'G-FW2SCXFXVK'
const metaId = process.env.NEXT_PUBLIC_META_PIXEL_ID ?? '3434771583353275'

/** No scripts or telemetry are mounted inside private partner/admin workspaces. */
export default function PublicAnalytics() {
  const pathname = usePathname()
  const ready = useSyncExternalStore(subscribe, clientReady, serverReady)
  if (!ready || isPrivateWorkspaceUrl(window.location.href) || isPrivateWorkspaceUrl(pathname)) return null
  const guard = `if(location.hostname.startsWith('partner.') || /^\\/(partner|admin)(\\/|$)/.test(location.pathname)) return;`
  // Vercel Web Analytics / Speed Insights were removed (Oct 2026): PostHog
  // already covers page views and web vitals, and each of their beacons was a
  // Vercel CDN request against the Hobby plan's 1M/month.
  return <>
    <Script src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`} strategy="lazyOnload" />
    <Script id="google-analytics" strategy="lazyOnload">{`(function(){${guard}window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config',${JSON.stringify(gaId)});})();`}</Script>
    <Script id="meta-pixel" strategy="lazyOnload">{`(function(){${guard}!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init',${JSON.stringify(metaId)});fbq('track','PageView');})();`}</Script>
  </>
}
